import Services from './base-services'

const service = new Services('achievement')
import mapParameters from '../utils/map-parameters'

export default {
    getAllAchievements() {
        return service.get('getAllAchievements')
    },
    getAchievementsByUser(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getAchievementsByUser', params)
    },
    getAccomplishedByUser(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getAccomplishedByUser', params)
    }
}
